import type { TFunction } from "i18next";
import { Icon } from "../../Icon";

const OccupationStatusWidget = ({ isOccupied, t }: { isOccupied: boolean; t: TFunction; }) => {
    return (
        <div className={`relative overflow-hidden rounded-2xl border transition-all duration-300 ${!isOccupied
            ? 'bg-success/5 border-success/20'
            : 'bg-base-200/50 border-base-300/20'
            }`}>
            <div className="p-5 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    {/* Icon with dynamic status indicator */}
                    <div className="relative">
                        <div className={`${!isOccupied ? 'bg-success/10 text-success' : 'bg-base-300 text-base-content/30'
                            } rounded-2xl p-2.5 flex items-center justify-center shrink-0 border border-base-200`}>
                            <Icon name="event_available" className="text-2xl" />
                        </div>

                        {/* Status dot in the corner of the icon */}
                        <span className={`absolute -top-1 -right-1 flex h-4 w-4 border-2 border-base-100 rounded-full ${!isOccupied ? 'bg-success' : 'bg-base-content/20'
                            }`}>
                            {!isOccupied && (
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
                            )}
                        </span>
                    </div>

                    <div>
                        <h3 className="text-[10px] font-black uppercase tracking-[0.2em] opacity-40 mb-1">
                            {t('poiModal.availability')}
                        </h3>
                        <p className={`text-sm font-black leading-tight uppercase ${!isOccupied ? 'text-success' : 'opacity-60'
                            }`}>
                            {isOccupied ? t('poiModal.isOccupied') : t('poiModal.free')}
                        </p>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default OccupationStatusWidget;